import axios from "axios";

const API_URL = "/api/prospects";

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token && { auth: token }),
  };
};

const handleRequest = async (url, options = {}) => {
  try {
    const response = await axios({
      url,
      method: options.method || "GET",
      headers: getHeaders(),
      data: options.data,
    });

    const data = response.data;

    if (data && typeof data.success !== "undefined") {
      return data;
    }

    return {
      success: true,
      data,
      message: data?.message || "",
    };
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data;
    let message = data?.message;

    if (!message) {
      if (status === 401 || status === 403) {
        message = "You are not authorized to perform this action.";
      } else if (status >= 500) {
        message = "Server error occurred. Please try again later.";
      } else if (status) {
        message = "Request failed. Please try again.";
      } else {
        message = "Network error. Please check your internet connection.";
      }
    }

    return {
      success: false,
      data: null,
      message,
    };
  }
};

export const prospectService = {
  getProspects: async (page = 1, limit = 50, salesExecutive = "", filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (salesExecutive) params.append("salesExecutive", salesExecutive);
    if (filters.search) params.append("search", filters.search);
    if (filters.quickFilterValues?.length) {
      params.append("quickFilters", JSON.stringify(filters.quickFilterValues));
    }
    if (filters.items?.length) params.append("filters", JSON.stringify(filters.items));
    return handleRequest(`${API_URL}?${params.toString()}`);
  },

  getProspect: async (id) => {
    return handleRequest(`${API_URL}/${id}`);
  },

  createProspect: async (data) => {
    return handleRequest(API_URL, { method: "POST", data });
  },

  updateProspect: async (id, data) => {
    return handleRequest(`${API_URL}/${id}`, { method: "PUT", data });
  },

  deleteProspect: async (id) => {
    return handleRequest(`${API_URL}/${id}`, { method: "DELETE" });
  },

  getPendingCount: async (salesExecutive = "") => {
    const params = new URLSearchParams();
    if (salesExecutive) params.append("salesExecutive", salesExecutive);
    const query = params.toString();
    return handleRequest(`/api/prospects-pending-count${query ? `?${query}` : ""}`);
  },
};
